import React from "react";
import { useDispatch, useSelector } from "react-redux";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { Grid, Typography, Button } from "@material-ui/core";
import useMediaQuery from "@mui/material/useMediaQuery";
import useIsDesktop from "../hooks/useIsDesktop";
import { BUTTON_COLOR, TEXT_COLOR } from "../utils/constant";
import {
  addToCart,
  addQuantity,
  subtractQuantity,
} from "../store/actions/cartActions";

const AddItemButton = function (props) {
  const {
    lineItem,
    setSelectedItem,
    setModifierPopup,
    setIsRepeatation,
    storeInfo,storeInfoConfig,
    isDisabled,
    isOutOfStock,
  } = props;

  const dispatch = useDispatch();
  const isDesktop = useIsDesktop();
  const cartProps = useSelector((state) => state.cartReducer);

  let primaryColor =  storeInfoConfig?.general_config?.primary_color;
  let secondaryColor =  storeInfoConfig?.general_config?.secondary_color;


  const addQty = (item) => {
    dispatch(addQuantity(item));
  };

  const removeQty = (item) => {
    dispatch(subtractQuantity(item));
  };

  const addToCartItem = (item) => {
    dispatch(addToCart(item));
  };

  const handleAddButton = (item) => {
    setSelectedItem(item);
    if (
      item.item_variant?.length > 1 ||
      item.item_variant[0]?.item_addons?.length
    ) {
      setModifierPopup(true);
    } else {
      addToCartItem(item);
    }
  };

  const getAddedItemQty = (id) => {
    const cartItem = cartProps?.addedItems?.find(
      (e) => e?.itemUniqueId === id
    );
    return cartItem?.quantity ? cartItem.quantity : 0;
  };

  const checkAddedItem = (id) => {
    const cartItem = cartProps?.addedItems?.find((e) => e?._id === id);
    return cartItem ? true : false;
  };

  return checkAddedItem(lineItem?._id) ? (
    <Grid
      style={{
        display: "flex",
        flexDirection: "column",
        alignContent: "flex-end",
        flexWrap: "wrap",
        justifyContent: "flex-end",
        alignItems: "baseline",
      }}
    >
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        style={{
          float: "right",
          display: "flex",
          padding: "0px 5px",
          // boxShadow:
          //   "0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)",
          justifyContent: "space-evenly",
          alignContent: "center",
          alignItems: "center",
          border: `2px solid ${primaryColor || BUTTON_COLOR}`,
          minWidth: "5.5em",
          borderRadius: "0.6rem",
          backgroundColor: primaryColor|| BUTTON_COLOR,
        }}
      >
        <Grid container xs={4} sm={4} md={4} lg={4}>
          <RemoveIcon
            style={{
              color: "white",
              backgroundColor: primaryColor|| BUTTON_COLOR,
              height: "25px",
              width: "15px",
              borderRadius: "0.3rem 0rem 0rem 0.3rem",

              // padding: "0rem 0.3rem",
            }}
            onClick={() => removeQty(lineItem)}
          />
        </Grid>
        <Grid
          xs={4}
          sm={4}
          md={4}
          lg={4}
          style={{
            display: "flex",
            color: "white",
            justifyContent: "center",
            backgroundColor: primaryColor|| BUTTON_COLOR,
          }}
        >
          <Typography>
            <span
              style={{
                fontSize: "1.1rem",
                color: "white",
                fontWeight: "700",
              }}
            >
              {getAddedItemQty(lineItem?.itemUniqueId)}
            </span>
          </Typography>
        </Grid>
        <Grid container justifyContent="flex-end" xs={4} sm={4} md={4} lg={4}>
          <AddIcon
            style={{
              height: "25px",
              width: "15px",
              color: "white",
              backgroundColor: primaryColor|| BUTTON_COLOR,
              borderRadius: "0rem 0.3rem 0.3rem 0rem",
            }}
            onClick={() =>
              lineItem.item_variant?.length > 1
                ? (setIsRepeatation(true), setSelectedItem(lineItem))
                : getAddedItemQty(lineItem?.itemUniqueId)
                ? addQty(lineItem)
                : addToCartItem(lineItem)
            }
          />
        </Grid>
      </Grid>

      <Grid>
        {(lineItem.item_variant?.length > 1 ||
          (lineItem.item_variant?.[0]?.item_addons?.length > 0 &&
            !lineItem.item_variant[0].item_addons.includes(""))) && (
          <Typography>
            <span
              style={{
                fontSize: "0.9rem",
                marginLeft: "1rem",
                fontWeight: "500",
                color: "#212121",
                fontFamily: "Satoshi, sans-serif",
              }}
            >
              Customise
            </span>
          </Typography>
        )}
      </Grid>
    </Grid>
  ) : (
    <Button
      disabled={isDisabled || isOutOfStock}
      onClick={() => handleAddButton(lineItem)}
      variant="contained"
      style={{
        float: "right",
        minWidth: "5.5rem",
        padding: isOutOfStock ? "0.2rem 0.6rem" : "0.3rem 1rem",
        borderRadius: "0.6rem",
        color: primaryColor || BUTTON_COLOR,
        backgroundColor: "#ffffff",
        border: `1px solid ${isOutOfStock ? "#E5E5E5" : (primaryColor || BUTTON_COLOR)}`,
        cursor: isOutOfStock ? "not-allowed" : "pointer",
        opacity: 1,
        boxShadow: isOutOfStock ? "0px 3px 8px rgba(0, 0, 0, 0.14)" : "none",
      }}
    >
      {isOutOfStock ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            lineHeight: 1.15,
            color: "#d32f2f",
          }}
        >
          <span style={{ fontSize: isDesktop ? "12px" : "0.95rem", fontWeight: 700, color: "#d32f2f" }}>
            Out Of
          </span>
          <span style={{ fontSize: isDesktop ? "12px" : "0.95rem", fontWeight: 700, color: "#d32f2f" }}>
            Stock
          </span>
        </div>
      ) : (
        "Add"
      )}
    </Button>
  );
};

export default AddItemButton;
